import { onError } from '@apollo/client/link/error'
import { captureException } from '@sentry/react'

export const sentryOnErrorLink = onError(
  ({ graphQLErrors, networkError, operation }) => {
    const context = operation.getContext()
    const requestId = context.response?.headers?.get('x-paycom-request-id')

    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        captureException(new Error(message), {
          extra: {
            errorMessage: message,
            operationName: operation.operationName,
            variables: operation.variables,
            locations,
            path,
            requestId
          }
        })
      })
    }

    if (networkError) {
      captureException(networkError, {
        extra: {
          errorMessage: networkError.message,
          operationName: operation.operationName,
          variables: operation.variables,
          requestId
        }
      })
    }
  }
)
